<template lang="pug">
.card.finance-scoring-request
  .card-header {{ $t('requestTitle', { model: model.description, id: request.id }) }}
  .card-body
    .col-lg-8.col-xl-6
      fi-data-field(:label = '$t("date")') {{ $t('common:formatDatetime', { value: request.createdAt }) }}
      fi-data-field(:label = '$t("scoringModel")') {{ model.modelName }}
      fi-data-field(:label = '$t("idCode")') {{ request.idCode }}
      fi-data-field(:label = '$t("name")') {{ customerName(request) }}
      template(v-if = '!isPreScoringModel')
        fi-data-field(:label = '$t("loanAmount")') {{ loanAmount }}
        fi-data-field(:label = '$t("loanLength")') {{ loanLength }}
        fi-data-field(:label = '$t("ageAfterLoanPeriod")') {{ ageAfterLoanPeriod }}
      fi-data-field(:label = '$t("obligations")') {{ obligations }}
      fi-data-field(:label = '$t("netIncome")') {{ netIncome }}
      template(v-if = '!isPreScoringModel')
        fi-data-field(:label = '$t("idDocumentType")') {{ idDocumentType }}
        fi-data-field(:label = '$t("idDocumentNumber")') {{ idDocumentNumber }}
</template>


<script>
import FiDataField from '@/components/FiDataField'
import { mapGetters } from 'vuex'

export default {
  name: 'finance-scoring-request',

  components: { FiDataField },

  props: {
    request: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },

  i18nOptions: {},

  computed: {
    ...mapGetters('classifiers', ['classifierById']),
    ...mapGetters('customers', ['customerName']),
    isPreScoringModel () {
      return this.model.modelName === 'preScoring'
    },
    loanAmount () {
      return this.pickValue(['loanAmount', 'requestedLoanAmount', 'amount'])
    },
    loanLength () {
      return this.pickValue(['loanLength', 'period', 'term'])
    },
    ageAfterLoanPeriod () {
      return this.pickValue(['ageAfterLoanPeriod', 'companyAge', 'age'])
    },
    obligations () {
      return this.pickValue(['obligations', 'currentDebtAmount', 'historicalDebtAmount'])
    },
    netIncome () {
      return this.pickValue(['netIncome', 'currentNetIncome', 'income'])
    },
    idDocumentType () {
      const idDocId = this.pickValue(['idDocId', 'idDocumentTypeId'])
      return this.classifierById('idDocs', idDocId).human
    },
    idDocumentNumber () {
      return this.pickValue(['idDocNumber', 'idDocumentNumber'])
    }
  },

  methods: {
    pickValue (keys) {
      for (const key of keys) {
        const value = this.request[key]
        if (value !== null && value !== undefined && value !== '') return value
      }
      return ''
    }
  }
}
</script>


<i18n>
en:
  requestTitle:       "{{model}} request #{{id}}"
  date:               "Date"
  scoringModel:       "Scoring model"
  idCode:             "ID code"
  name:               "Name"
  loanAmount:         "Loan amount"
  loanLength:         "Loan length"
  ageAfterLoanPeriod: "Age after loan period"
  obligations:        "Obligations"
  netIncome:          "Net income"
  idDocumentType:     "ID document type"
  idDocumentNumber:   "ID document number"
et:
  requestTitle:       "{{model}} request #{{id}}"
  date:               "Date"
  scoringModel:       "Otsingumudel"
  idCode:             "Isikukood"
  name:               "Nimi"
  loanAmount:         "Taotletav finantseeringu summa"
  loanLength:         "Perioodi pikkus kuudes"
  ageAfterLoanPeriod: "Taotleja vanus perioodi löpus"
  obligations:        "Taotleja olemasolevad finantskohustused"
  netIncome:          "Taotleja netosissetuleku summa"
  idDocumentType:     "Konto avaja documendi tüüp"
  idDocumentNumber:   "Dokumendi number"
ru:
  requestTitle:       "{{model}} request #{{id}}"
  date:               "Дата"
  scoringModel:       "Scoring model"
  idCode:             "ID код"
  name:               "Имя"
  loanAmount:         "Сумма кредита"
  loanLength:         "Срок кредита"
  ageAfterLoanPeriod: "Возраст по окончании кредита"
  obligations:        "Финансовые обязательства"
  netIncome:          "Доход"
  idDocumentType:     "Тип ID документа"
  idDocumentNumber:   "Номер ID документа"
</i18n>
